export class AudioFileBoxAdapter {
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get startInSeconds() { return this.#box.startInSeconds.getValue(); }
    get endInSeconds() { return this.#box.endInSeconds.getValue(); }
    get data() { return this.getOrCreateLoader().data; }
    get peaks() { return this.getOrCreateLoader().peaks; }
    getOrCreateLoader() {
        return this.#context.sampleManager.getOrCreate(this.#box.address.uuid);
    }
    terminate() { }
}
